"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatusDot = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const useTaskStatusColor_1 = require("../hooks/useTaskStatusColor");
const StyledDiv = styled_components_1.default.div `
  height: 10px;
  min-width: 10px;
  margin-bottom: 2.5px;
  border-radius: 100%;
`;
const TaskStatusDot = props => {
    const { task } = props;
    const { color, label } = (0, useTaskStatusColor_1.useTaskStatusColor)({ task });
    return (react_1.default.createElement(core_1.Tooltip, { arrow: true, title: label, placement: 'top' },
        react_1.default.createElement(StyledDiv, { style: color, className: 'status-circle' })));
};
exports.TaskStatusDot = TaskStatusDot;
exports.default = exports.TaskStatusDot;
//# sourceMappingURL=TaskStatusDot.js.map